import React from 'react';
import DiagnosisHome from '../../../../components/Diagnosis/DiagnosisHome';
import { getButtonStates } from '../../../../utils/permissionService';

interface DiagnosisProps {
  gender?: 'MALE' | 'FEMALE';
  onDataCountChange?: (count: number) => void;
}

const Diagnosis: React.FC<DiagnosisProps> = ({ gender, onDataCountChange }) => {
  const {  canEdit, canAdd } = getButtonStates('Clinical', 'Investigations', 'Test', gender === 'MALE' ? 'male' : gender === 'FEMALE' ? 'female' : undefined);
  

  const handleAddClick = () => {

  };

  return (
    <div>
      <DiagnosisHome onAddClick={handleAddClick} permissions={{ canAdd, canEdit }} onDataCountChange={onDataCountChange}/>
    </div>
  );
};

export default Diagnosis;
